<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Ombor Qoldig'i</h2>

        <div class="header-actions">

          <!-- Brend Filtr -->
          <div class="filter-select-container">
            <select v-model="filter.model_id" class="status-select" @change="fetchProducts(true)">
              <option :value="null">Barcha Modellar</option>
              <option v-for="m in modelList" :key="m.id" :value="m.id">{{ m.name }}</option>
            </select>
          </div>

          <!-- Model Filtr -->
          <div class="filter-select-container">
            <select v-model="filter.model_id" class="status-select" @change="fetchProducts">
              <option :value="null">Barcha Modellar</option>
              <option v-for="m in modelList" :key="m.id" :value="m.id">{{ m.name }}</option>
            </select>
          </div>

          <!-- Qidiruv -->
          <div class="search-container">
            <input type="text" v-model="filter.keyword" @input="onSearch" class="search-input"
              placeholder="Nomi bo'yicha qidirish...">
          </div>

          <Top />
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper" @scroll="handleScroll" ref="tableContainer">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px">№</th>
                <th>MAHSULOT NOMI</th>
                <th>BREND / MODEL</th>
                <th>NARX (SOTISH)</th>
                <th style="text-align: center;">QOLDIQ</th>
              </tr>
            </thead>
            <tbody>
              <<tr v-for="(item, index) in productlist" :key="item.id">
                <!-- ID -->
                <td><span class="id-badge">{{ item.id }}</span></td>

                <!-- Mahsulot Nomi -->
                <td>
                  <div class="font-bold text-dark">{{ item.name || item.extra_name }}</div>
                  <div class="text-muted small" v-if="item.code">Kod: {{ item.code }}</div>
                </td>

                <!-- Brend va Model -->
                <td>
                  <div class="text-dark font-weight-bold">{{ item.brand_name }}</div>
                  <div class="text-muted small">{{ item.model_name}}</div>
                </td>

                <!-- Narx -->
                <td class="price blue">
                  {{ formatSumma(getProductPrice(item)) }} <small>so'm</small>
                </td>

                <!-- Qoldiq (Status o'rnida) -->
                <td style="text-align: center;">
                  <span class="tag" :class="item.balance > 0 ? 'green-tag' : 'red-tag'">
                    {{ item.balance || 0 }} 
                  </span>
                </td>

                </tr>

                <!-- BO'SH HOLAT -->
                <tr v-if="!loading && productlist.length === 0">
                  <td colspan="5" class="empty-row">
                    <div class="py-5 text-center">
                      <b-icon icon="box-seam" font-scale="3" class="mb-3 text-light"></b-icon>
                      <p class="text-muted">Omborda mahsulot topilmadi</p>
                    </div>
                  </td>
                </tr>

                <!-- LOADING -->
                <tr v-if="loading">
                  <td colspan="5" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Yuklanmoqda...</span>
                    </div>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import Top from '../Layout/Top.vue';

export default {
  name: 'OmborQoldiq',
  components: { Top },
  data() {
    return {
      loading: false,
      brandList: [],
      modelList: [],
      productlist: [],

      // Pagination uchun yangi o'zgaruvchilar
      page: 1,
      limit: 50, // Bir martada 50 ta yuklaymiz (tezroq ishlashi uchun)
      hasMore: true, // Yana ma'lumot bormi?

      filter: {
        brand_id: null,
        model_id: null,
        keyword: '',
      }
    };
  },
  mounted() {
    this.fetchBrands();
    this.fetchProducts(true); // true = ro'yxatni tozalab yangidan yuklash
  },
  methods: {
    formatSumma(s) {
      return Number(s || 0).toLocaleString().replace(/,/g, ' ');
    },
    getProductPrice(item) {
      return item.price_register ? item.price_register.chakana_price : 0;
    },

    async fetchBrands() {
      try {
        const res = await axios.get('api/v1/brand/');
        this.brandList = res.data;
      } catch (e) { console.error(e); }
    },

    async onBrandChange() {
      this.filter.model_id = null;
      if (this.filter.brand_id) {
        try {
          const res = await axios.get(`api/v1/model/?brand_id=${this.filter.brand_id}`);
          this.modelList = res.data;
        } catch (e) { this.modelList = []; }
      } else {
        this.modelList = [];
      }
      this.fetchProducts(true); // Brend o'zgarsa yangidan yuklaymiz
    },

    // Qidiruv va Model o'zgarganda
    onFilterChange() {
      this.fetchProducts(true);
    },

    onSearch: debounce(function () {
      this.fetchProducts(true);
    }, 500),

    // Scroll hodisasi
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      // Agar pastga yetib qolsa (50px qolganda) va hozir yuklanmayotgan bo'lsa
      if (scrollHeight - scrollTop <= clientHeight + 50 && !this.loading && this.hasMore) {
        this.page += 1;
        this.fetchProducts(false); // false = davomiga qo'shish
      }
    },

    /**
     * @param {boolean} reset - Agar true bo'lsa ro'yxatni tozalaydi (yangi qidiruv), false bo'lsa davomiga qo'shadi
     */
    async fetchProducts(reset = false) {
      if (reset) {
        this.page = 1;
        this.hasMore = true;
        this.productlist = [];
        // Scrollni tepaga qaytarish
        if (this.$refs.tableContainer) this.$refs.tableContainer.scrollTop = 0;
      }

      // Agar data tugagan bo'lsa so'rov yuborma
      if (!this.hasMore && !reset) return;

      this.loading = true;
      try {
        const skladId = localStorage.getItem('sklad_id');

        const res = await axios.post('api/v1/product/all-price-balance/0', {
          sklad_id: Number(skladId),
          keyword: this.filter.keyword,
          model_id: this.filter.model_id,
          brand_id: this.filter.brand_id,
          limit: this.limit,
          page: this.page,
        });

        const newData = res.data;

        if (reset) {
          this.productlist = newData;
        } else {
          // Eski ro'yxatga yangisini qo'shamiz
          this.productlist = [...this.productlist, ...newData];
        }

        // Agar kelgan ma'lumot limitdan kam bo'lsa, demak boshqa ma'lumot yo'q
        if (newData.length < this.limit) {
          this.hasMore = false;
        }

      } catch (e) {
        console.error(e);
        if (reset) this.productlist = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* ASOSIY CONTAINER */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
  gap: 15px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

/* INPUT VA SELECTLAR */
.status-select,
.search-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 15px;
  font-weight: 600;
  color: #475569;
  outline: none;
  background: white;
  transition: all 0.2s;
  font-size: 14px;
}

.status-select {
  cursor: pointer;
  min-width: 150px;
}

.search-input {
  min-width: 200px;
}

.status-select:focus,
.search-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* JADVAL CARD */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

/* JADVAL STYLES */
.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

.price.blue {
  color: #2563eb;
  font-weight: 800;
  font-size: 15px;
}

/* TAGLAR (QOLDIQ UCHUN) */
.tag {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  display: inline-block;
}

.tag.green-tag {
  background: #ecfdf5;
  color: #10b981;
}

.tag.red-tag {
  background: #fee2e2;
  color: #ef4444;
}

/* SCROLLBAR */
.table-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
</style>